import { Theme } from "../../appearance/Themes";
import { themeAtom } from "../atoms";
import { useAtomValue } from "jotai";
import React from "react";

export type RatingLabel = keyof Theme["myVesselsTableRow"]["rating"];
export type RatingKey = RatingLabel;

interface Props {
  label: RatingKey;
}

const Rating: React.FC<Props> = ({ label }) => {
  const theme = useAtomValue(themeAtom);
  const ratingMap = theme.myVesselsTableRow.rating;
  const rating = ratingMap[label];
  if (!rating) return null;

  return (
    <div
      className="relative h-[16px] w-[20px] font-bold"
      style={{
        backgroundColor: rating.bgColor,
        clipPath: "polygon(0% 0%, 75% 0%, 100% 50%, 75% 100%, 0% 100%)",
      }}
    >
      <span
        className="absolute left-1/2 top-1/2 -translate-x-[70%] -translate-y-1/2 text-center"
        style={{ color: rating.textColor }}
      >
        {label}
      </span>
    </div>
  );
};

export default Rating;
